import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Box } from '@chakra-ui/react';

interface Props {
  initialValue?: string;
  placeholder?: string;
  onChange?: (content: string) => void;
}

const TextEditor: React.FC<Props> = ({ initialValue = '', placeholder = '', onChange }) => {
  return (
    <Box mb={4} position={'relative'} width={'100%'}>
      <style>
        {`
            .ck.ck-editor,
            .ck-rounded-corners .ck.ck-toolbar {
              border-radius: 0.375rem;
            }
            .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{
              border-radius: 0.375rem;
              border-bottom-left-radius: 0;
              border-bottom-right-radius: 0;
              border-color: #E2E8F0; 
            }
            .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{
              border-radius: 0.375rem;
              border-top-left-radius: 0;
              border-top-right-radius: 0;
              border-color: #E2E8F0; 
            }
            .ck-content {
              color: var(--chakra-colors-fg-muted);
              font-size: var(--chakra-font-sizes-sm);
              line-height: 1.7em;
            }
            .ck-editor__editable:not(.ck-editor__nested-editable) { 
              min-height: 100px;
              padding-left: 1rem;
              padding-right: 1rem;
            }
            .ck-content .table {
              width: 100%;
              table-layout: auto;
              text-align: start;
              line-height: 1.5em;
              margin: auto;
              margin-bottom: 10px;
            }
            .ck-content :is(h1,h2,h3,h4,h5,hr)+* {
              margin-top: 0;
            }
            .ck-content h2 {
              font-size: 1.4em;
              letter-spacing: -0.02em;
              margin-top: 1.6em;
              margin-bottom: 0.8em;
              line-height: 1.4em;
            }
            .ck-content h3 {
              font-size: 1.285em;
              letter-spacing: -0.01em;
              margin-top: 1.5em;
              margin-bottom: 0.4em;
              line-height: 1.5em;
            }
            .ck-content h4 {
              margin-top: 1.4em;
              margin-bottom: 0.5em;
              letter-spacing: -0.01em;
              line-height: 1.5em;
            }
            .ck-content h1, .ck-content h2, .ck-content h3, .ck-content h4 {
              color: var(--chakra-colors-fg);
              font-weight: 600;
            }
            .ck-content ul {
              margin-top: 1em;
              margin-bottom: 1em;
              -webkit-padding-start: 1.5em;
              padding-inline-start: 1.5em;
            }
            .ck-content ul>li {
              -webkit-padding-start: 0.4em;
              padding-inline-start: 0.4em;
              list-style-type: disc;
            }
            .ck-content ol {
              margin-top: 1em;
              margin-bottom: 1em;
              -webkit-padding-start: 1.5em;
              padding-inline-start: 1.5em;
            }
            .ck-content ol>li {
              -webkit-padding-start: 0.4em;
              padding-inline-start: 0.4em;
              list-style-type: decimal;
            }
            .ck-content p {
              margin-top: 1em;
              margin-bottom: 1em;
            }
          `}
      </style>
      <CKEditor
        editor={ClassicEditor as any}
        data={initialValue}
        config={{
          placeholder: placeholder,
          toolbar: [
            'heading',
            'bold',
            'italic',
            'insertTable',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo',
          ],
        }}
        onChange={(_, editor) => {
          const data = editor.getData();
          onChange?.(data);
        }}
      />
    </Box>
  );
};

export default TextEditor;
